import React from "react";
import { cn } from "../../../lib/utils";

type CredentialShareToggleProps = {
  checked: boolean;
  disabled?: boolean;
  onClick: () => void;
};

export const CredentialShareToggle: React.FC<CredentialShareToggleProps> = ({
  checked,
  disabled,
  onClick,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label="Share link"
    disabled={disabled}
    onClick={onClick}
    className={cn(
      "relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border border-transparent transition-colors",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
      "disabled:cursor-not-allowed disabled:opacity-50",
      checked ? "bg-primary" : "bg-muted",
    )}
  >
    <span
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full bg-background shadow transition-transform",
        checked ? "translate-x-5" : "translate-x-0.5",
      )}
    />
  </button>
);
